<app-images-base />
<div class="container">
  <app-popular-categories />
  <app-popular-search-requests />
  <app-banner />
  @defer {
    <app-they-use-image-base />
  } @placeholder {
    <div class="they-use-image-base-placeholder"></div>
  }
</div>
